import { normalizePeriodName } from './scheduleTargetUtils';

export const PERMANENT_START_TIMES = {
  bloodPressure: {
    'Wake-up': '06:01 AM',
    Morning: '08:01 AM',
    Noon: '11:01 AM',
    Afternoon: '02:01 PM',
    Evening: '06:01 PM'
  },
  bloodGlucose: {
    'Wake-up Time': '06:00 AM',
    'Before-Breakfast': '07:01 AM',
    'After-Breakfast': '09:01 AM',
    'Before-Lunch': '11:01 AM',
    'After-Lunch': '01:01 PM',
    'Before-Dinner': '05:01 PM',
    'After-Dinner': '07:01 PM',
    Bedtime: '08:30 PM',
    Midnight: '10:00 PM'
  },
  weight: {
    Morning: '06:00 AM',
    Afternoon: '12:00 PM',
    Evening: '06:00 PM'
  }
};

export const convertTimeToMinutes = (timeStr) => {
  if (!timeStr) return null;
  if (timeStr.includes('AM') || timeStr.includes('PM')) {
    const [time, meridiem] = timeStr.trim().split(' ');
    const [hh, mm] = time.split(':').map(Number);
    if (!Number.isFinite(hh) || !Number.isFinite(mm)) return null;
    let hour = hh;
    if (meridiem?.toUpperCase() === 'PM' && hour !== 12) hour += 12;
    if (meridiem?.toUpperCase() === 'AM' && hour === 12) hour = 0;
    return hour * 60 + mm;
  }
  const [h, m] = timeStr.split(':').map(Number);
  if (!Number.isFinite(h) || !Number.isFinite(m)) return null;
  return h * 60 + m;
};

export const getCurrentTimeHHmm = () => new Date().toTimeString().slice(0, 5);

export const getUniquePeriods = (periods = []) => {
  const seen = new Set();
  return (Array.isArray(periods) ? periods : []).filter((period) => {
    const key = normalizePeriodName(period?.name);
    if (!key || seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};

export const getInstantPeriodOptions = (periods = [], permanentStartTimes = {}) => {
  const uniqueFetched = getUniquePeriods(periods);
  if (uniqueFetched.length > 0) return uniqueFetched;
  return Object.keys(permanentStartTimes || {}).map((name) => ({ id: null, name }));
};

export const determinePeriodFromTime = (timeStr, periods = [], permanentStartTimes = {}) => {
  const current = convertTimeToMinutes(timeStr);
  if (current == null) return null;

  const matches = (Array.isArray(periods) ? periods : [])
    .map((period) => {
      const fixedStart = permanentStartTimes[period?.name] || '';
      const startTime = fixedStart || period?.startTime || period?.start;
      const endTime = period?.endTime || period?.end;
      const start = convertTimeToMinutes(startTime);
      const end = convertTimeToMinutes(endTime);
      if (start == null || end == null) return null;

      const isOvernight = end < start;
      const inRange = isOvernight
        ? current >= start || current <= end
        : current >= start && current <= end;
      if (!inRange) return null;

      const duration = isOvernight ? (1440 - start + end) : (end - start);
      return {
        name: period?.name || '',
        isOvernight,
        duration
      };
    })
    .filter(Boolean);

  if (matches.length === 0) return null;

  matches.sort((a, b) => {
    if (a.isOvernight !== b.isOvernight) return a.isOvernight ? 1 : -1;
    return a.duration - b.duration;
  });

  return matches[0]?.name || null;
};

export const determinePeriodFromCurrentTime = (periods = [], permanentStartTimes = {}) =>
  determinePeriodFromTime(getCurrentTimeHHmm(), periods, permanentStartTimes);

